<template>
  <div class="d-flex flex-column align-items-center justify-content-center" style="height: 80vh;">
    <h2>🎉 Thank you!</h2>
    <p>Your Stripe account has been connected successfully.</p>

    <p v-if="accountId"><strong>Account ID:</strong> {{ accountId }}</p>

    <b-button variant="primary" @click="$router.push('/dash')">
      Back to Dashboard
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'StripeOnboardingReturn',
  data() {
    return {
      accountId: null,
    };
  },
  async created() {
    try {
      const params = new URLSearchParams(window.location.search);
      const accountId = params.get('accountId');
      const userId = params.get('userId');

      if (!accountId || !userId) return;

      // Call backend to finalize onboarding
      const res = await fetch(
        `https://gunter-backend.soonforward.us/onboarding/return?accountId=${accountId}&userId=${userId}`,
      );
      const data = await res.json();

      if (data.accountId || data.message) {
        this.accountId = accountId;
      }
    } catch (err) {
      console.error('Error finalizing onboarding', err);
    }
  },
};
</script>
